/* Reference data transcribed from Paul Curd's Facility_Asset_Assessment_Scorecard.xlsm:
   sheet 'Equipment ' for the classification dropdowns, the four '* Life Expect. Table' sheets for
   expected lifetimes. Generated — regenerate rather than hand-edit if the workbook changes.

   The app previously shipped an independently invented taxonomy sharing only ~7% of its names with
   the workbook, so an assessor working from Paul's sheet could not find their equipment. These are
   his exact dropdown values, verbatim including his spellings.

   The workbook cannot map a dropdown value to a lifetime by itself: its dropdowns and life tables
   use different vocabularies (77 of 81 mechanical dropdown values have no life-table row of the
   same name), which is why the sheet tells the assessor to "Go To Table" and read RSL off by hand.
   The tables below are that missing mapping layer.

   Lifetimes are keyed by system, not by name alone: 'Relay' is 20 years in Electrical but 10 in
   Controls, and 'Thermometer' 20 in Plumbing but 15 in Controls. A flat name->years map silently
   picked one and applied it to both. */

export const MECHANICAL_ASSETS: string[] = [
  'Air Conditioner',
  'Air Handling Unit - Constant Volume',
  'Air Handling Unit - Dedicated Outdoor Air',
  'Air Handling Unit - Variable Volume',
  'Air Separator',
  'Air Terminal - Constant Volume',
  'Air Terminal - Variable Volume',
  'Air Washer',
  'Boiler - Hot Water',
  'Boiler - Steam',
  'Burner',
  'Chemical Feed Tank',
  'Coil - Direct Expansion',
  'Coil - Fin Tube',
  'Coil - Steam',
  'Coil - Water',
  'Compressor',
  'Condensing Unit',
  'Cooling Tower - Closed Loop',
  'Cooling Tower - Open Loop',
  'Damper',
  'Damper - Fire',
  'Damper - Minimum Outdoor',
  'Damper - Outdoor Air',
  'Damper - Relief/Exhaust Air',
  'Damper - Return Air',
  'Damper - Smoke',
  'Dehumidifier',
  'Diffuser, Register, Grille',
  'Duct Silencer',
  'Ductless Split System',
  'Ductwork - Access Door',
  'Ductwork - Exhaust Air',
  'Ductwork - Insulation',
  'Ductwork - Supply Air',
  'Energy Recovery Unit',
  'Energy Recovery Wheel',
  'Engine',
  'Exhaust Snorkel',
  'Expansion Tank',
  'Fan - Boiler Draft Inducer',
  'Fan - Exhaust',
  'Fan - Filter Fan Unit',
  'Fan - Relief',
  'Fan - Supply',
  'Fan Coil Unit',
  'Filter - Electro-Static',
  'Filter - Final Filter',
  'Filter - HEPA',
  'Filter - Pre Filter',
  'Fume Hood - Canopy',
  'Fume Hood - Kitchen',
  'Fume Hood - Laboratory',
  'Furnace - Electric',
  'Furnace - Fuel Fired',
  'Heat Exchanger - Plate and Frame',
  'Heat Exchanger - Shell and Tube',
  'Heat Pump - Air to Air',
  'Heat Pump - Water to Air',
  'Heat Pump - Water to Water',
  'Heater - Electric',
  'Heater -Hot Water',
  'Heater -Steam',
  'Humidifier - Steam',
  'Humidifier - Water',
  'Pump',
  'Pump - Booster',
  'Pump - Chilled Water',
  'Pump - Condenser Water',
  'Pump - Heating Water',
  'Pump - PreHeat Coil',
  'Pump - Vacuum',
  'Radiant Heater',
  'Roof Top Unit',
  'Turbine',
  'Unit Heater - Electric',
  'Unit Heater - Gas Fired',
  'Unit Heater - Hot Water',
  'Unit Heater - Steam',
  'Water Chiller - Air Cooled',
  'Water Chiller - Water Cooled',
];

export const ELECTRICAL_ASSETS: string[] = [
  'Automatic Transfer Switch',
  'Circuit Breaker - Arc Fault',
  'Circuit Breaker - Ground Fault',
  'Circuit Breaker - Main',
  'Circuit Breaker - Over Current',
  'Circuit Breaker - Tie',
  'Current Transformer',
  'Disconnect Switch - Fused',
  'Disconnect Switch - Non Fused',
  'Emergency Stop Switch',
  'Energy Monitor',
  'Fire - Alarm Panel',
  'Fire - Annuciator/Strobe',
  'Fire - Heat Detector',
  'Fire - Pull Station',
  'Fuse',
  'Generator - Emergency Power',
  'Generator - Standy Power',
  'Hand-Off-Auto Switch',
  'Heat Tape - Freeze Protection',
  'Heater - Compressor Crankcase',
  'Heater - Cooling Tower Sump',
  'Heater - Duct',
  'Lighting Control Panel',
  'Lighting Dimmer Switch',
  'Lighting Fixture - Emergency',
  'Lighting Fixture - Exit',
  'Lighting Fixture - Indoor',
  'Lighting Fixture - Night Light',
  'Lighting Fixture - Outdoor',
  'Lighting Fixture - Ultraviolet',
  'Motor',
  'Motor Control Center',
  'Motor Starter',
  'Occupancy Sensor',
  'Power Panel - Lighting',
  'Power Panel - Mechanical',
  'Relay',
  'Switch - Wall  On/Off',
  'Switchboard',
  'Transformer - Utility',
  'Transformer - Voltage Boost',
  'Transformer - Voltage Step Down',
  'TVSS - Surge Protection Device',
  'UPS',
  'Variable Frequency Drive',
];

export const PLUMBING_ASSETS: string[] = [
  'Air Compressor - Reciprocating',
  'Air Compressor - Screw',
  'Aquastat',
  'Back Flow Preventer',
  'Drain - Floor',
  'Drain - Roof',
  'Drain Cleanout',
  'Drinking Fountain',
  'Effluent Neutralizer',
  'Emergency Eye Wash',
  'Emergency Shower',
  'Expansion Tank',
  'Faucet - Duplex',
  'Faucet - Single',
  'Faucet - Spray Head',
  'Fire Hydrant',
  'Fire Sprinkler Head',
  'Flush Valve',
  'Hose Bib',
  'Lavatory',
  'Meter - Blow Down Water',
  'Meter - Make-up Water',
  'Meter - Natural Gas',
  'Meter - Water',
  'Pump - Domestic Water Booster',
  'Pump - Hot Water Circulating',
  'Pump - Sump',
  'Shock Arrestor',
  'Shower',
  'Sink - Kitchen',
  'Sink - Laboratory',
  'Sink - Mop',
  'Strainer',
  'Thermometer',
  'Trap',
  'Trap - Grease',
  'Trap - Primer',
  'Urinal',
  'Pump - Vacuum',
  'Valve - Balancing',
  'Valve - Check',
  'Valve - Gas Cock',
  'Valve - Isolation',
  'Valve - Post Indicator',
  'Valve - Pressure Relief',
  'Washer Hose Box',
  'Water Closet',
  'Water Cooler',
  'Water Heater - Electric',
  'Water Heater - Instantaneous',
  'Water Heater -Fuel  Fired',
  'Water Tempering Station',
];

export const CONTROLS_ASSETS: string[] = [
  'Automation System',
  'Computer - Automation System',
  'Control Valve - Actuator',
  'Control Valve -2-Way',
  'Control Valve -3-Way',
  'Controller - Automation System',
  'Controller - Dew Point',
  'Controller - Differential Pressure',
  'Controller - Economizer',
  'Controller - Flame Safeguard',
  'Controller - Heat Tape Temperature',
  'Controller - Humidity',
  'Controller - Pressure',
  'Controller - Temperature',
  'Damper - Barometric',
  'Damper - Motor Operated',
  'Damper Actuator',
  'Damper End Switch',
  'Differential Pressure Switch',
  'Freeze Stat',
  'Humdistat',
  'Magnehelic Gauge - Analog',
  'Magnehelic Gauge - Digital',
  'Meter - Electric',
  'Meter - Flow',
  'Meter - Natural Gas',
  'Meter - Water',
  'Refrigerant Monitor',
  'Relay',
  'Sensor - Air Flow',
  'Sensor - Carbon Dioxide',
  'Sensor - Carbon Monoxide',
  'Sensor - Current',
  'Sensor - Dew Point',
  'Sensor - Differential Pressure',
  'Sensor - Enthalpy',
  'Sensor - Humidity',
  'Sensor - Light Level',
  'Sensor - Methane',
  'Sensor - Occupancy',
  'Sensor - Temperature',
  'Sensor - Temperature & Humidity',
  'Sensor - Velocity',
  'Sensor - Water Flow',
  'Smoke Damper',
  'Smoke Detector',
  'Switch - Flow',
  'Switch - Freeze Protection',
  'Switch - High Pressure',
  'Thermometer',
  'Thermostat',
  'Vapor Detection System',
];

export const ASSET_LISTS: Record<string, string[]> = {
  controls: CONTROLS_ASSETS,
  electrical: ELECTRICAL_ASSETS,
  mechanical: MECHANICAL_ASSETS,
  plumbing: PLUMBING_ASSETS,
};

export type LifetimeBasis = 'exact' | 'item' | 'sub-match' | 'median';
/* How each lifetime was derived:
   - exact:     the dropdown name matched a life-table row outright
   - item:      matched the life-table Item and all its sub-variants share one lifetime
   - sub-match: matched the Item; sub-variant picked by name overlap
   - median:    the Item's sub-variants disagree; median used pending Paul's decision */

/* Expected service life in years, by system. A classification is absent when the workbook
   offers no basis at all — auto-RSL simply does not fire for it. */
export const LIFE_EXPECTANCY_BY_SYSTEM: Record<string, Record<string, number>> = {
  controls: {
    'Computer - Automation System': 10,
    'Control Valve - Actuator': 10,
    'Control Valve -2-Way': 10,
    'Control Valve -3-Way': 10,
    'Controller - Automation System': 15,
    'Controller - Dew Point': 15,
    'Controller - Differential Pressure': 15,
    'Controller - Economizer': 15,
    'Controller - Flame Safeguard': 15,
    'Controller - Heat Tape Temperature': 10,
    'Controller - Humidity': 15,
    'Controller - Pressure': 15,
    'Controller - Temperature': 15,
    'Damper - Barometric': 15,
    'Damper - Motor Operated': 15,
    'Damper Actuator': 15,
    'Damper End Switch': 15,
    'Freeze Stat': 10,
    'Humdistat': 15,
    'Magnehelic Gauge - Analog': 10,
    'Magnehelic Gauge - Digital': 10,
    'Meter - Electric': 25,
    'Meter - Flow': 20,
    'Meter - Natural Gas': 25,
    'Meter - Water': 25,
    'Refrigerant Monitor': 10,
    'Relay': 10,
    'Sensor - Air Flow': 10,
    'Sensor - Carbon Dioxide': 10,
    'Sensor - Carbon Monoxide': 10,
    'Sensor - Current': 10,
    'Sensor - Dew Point': 10,
    'Sensor - Differential Pressure': 10,
    'Sensor - Enthalpy': 10,
    'Sensor - Humidity': 10,
    'Sensor - Light Level': 10,
    'Sensor - Methane': 10,
    'Sensor - Occupancy': 10,
    'Sensor - Temperature': 10,
    'Sensor - Temperature & Humidity': 10,
    'Sensor - Velocity': 10,
    'Sensor - Water Flow': 10,
    'Smoke Damper': 10,
    'Smoke Detector': 10,
    'Switch - Flow': 15,
    'Switch - Freeze Protection': 10,
    'Switch - High Pressure': 10,
    'Thermometer': 15,
    'Thermostat': 15,
    'Vapor Detection System': 10,
  },
  electrical: {
    'Automatic Transfer Switch': 25,
    'Circuit Breaker - Arc Fault': 30,
    'Circuit Breaker - Ground Fault': 30,
    'Circuit Breaker - Main': 30,
    'Circuit Breaker - Over Current': 30,
    'Circuit Breaker - Tie': 30,
    'Disconnect Switch - Fused': 15,
    'Disconnect Switch - Non Fused': 20,
    'Emergency Stop Switch': 20,
    'Energy Monitor': 15,
    'Fire - Alarm Panel': 15,
    'Fire - Annuciator/Strobe': 20,
    'Fire - Heat Detector': 30,
    'Fire - Pull Station': 30,
    'Fuse': 5,
    'Generator - Emergency Power': 25,
    'Generator - Standy Power': 25,
    'Heat Tape - Freeze Protection': 10,
    'Heater - Compressor Crankcase': 10,
    'Heater - Cooling Tower Sump': 10,
    'Heater - Duct': 15,
    'Lighting Control Panel': 30,
    'Lighting Dimmer Switch': 15,
    'Lighting Fixture - Emergency': 20,
    'Lighting Fixture - Exit': 20,
    'Lighting Fixture - Indoor': 20,
    'Lighting Fixture - Night Light': 15,
    'Lighting Fixture - Outdoor': 20,
    'Lighting Fixture - Ultraviolet': 10,
    'Motor': 20,
    'Motor Control Center': 30,
    'Motor Starter': 20,
    'Power Panel - Lighting': 30,
    'Power Panel - Mechanical': 30,
    'Relay': 20,
    'Switch - Wall  On/Off': 30,
    'Switchboard': 30,
    'Transformer - Utility': 30,
    'Transformer - Voltage Boost': 30,
    'Transformer - Voltage Step Down': 3,
    'TVSS - Surge Protection Device': 10,
    'UPS': 10,
    'Variable Frequency Drive': 10,
  },
  mechanical: {
    'Air Conditioner': 15,
    'Air Handling Unit - Constant Volume': 25,
    'Air Handling Unit - Dedicated Outdoor Air': 20,
    'Air Handling Unit - Variable Volume': 25,
    'Air Terminal - Constant Volume': 20,
    'Air Terminal - Variable Volume': 20,
    'Air Washer': 15,
    'Boiler - Hot Water': 25,
    'Boiler - Steam': 25,
    'Burner': 20,
    'Coil - Direct Expansion': 15,
    'Coil - Fin Tube': 15,
    'Coil - Steam': 20,
    'Coil - Water': 20,
    'Compressor': 20,
    'Condensing Unit': 20,
    'Cooling Tower - Closed Loop': 20,
    'Cooling Tower - Open Loop': 20,
    'Damper': 20,
    'Damper - Fire': 20,
    'Damper - Minimum Outdoor': 20,
    'Damper - Outdoor Air': 20,
    'Damper - Relief/Exhaust Air': 20,
    'Damper - Return Air': 20,
    'Damper - Smoke': 20,
    'Ductwork - Access Door': 30,
    'Ductwork - Exhaust Air': 30,
    'Ductwork - Insulation': 30,
    'Ductwork - Supply Air': 30,
    'Energy Recovery Unit': 20,
    'Engine': 20,
    'Fan - Boiler Draft Inducer': 20,
    'Fan - Exhaust': 20,
    'Fan - Filter Fan Unit': 20,
    'Fan - Relief': 20,
    'Fan - Supply': 20,
    'Fan Coil Unit': 20,
    'Furnace - Electric': 20,
    'Furnace - Fuel Fired': 20,
    'Heat Exchanger - Plate and Frame': 25,
    'Heat Exchanger - Shell and Tube': 25,
    'Heat Pump - Air to Air': 15,
    'Heat Pump - Water to Air': 20,
    'Heat Pump - Water to Water': 20,
    'Pump': 10,
    'Pump - Booster': 10,
    'Pump - Chilled Water': 10,
    'Pump - Condenser Water': 10,
    'Pump - Heating Water': 10,
    'Pump - PreHeat Coil': 10,
    'Pump - Vacuum': 10,
    'Radiant Heater': 10,
    'Turbine': 30,
    'Unit Heater - Electric': 15,
    'Unit Heater - Gas Fired': 15,
    'Unit Heater - Hot Water': 20,
    'Unit Heater - Steam': 20,
  },
  plumbing: {
    'Air Compressor - Reciprocating': 10,
    'Air Compressor - Screw': 10,
    'Aquastat': 10,
    'Back Flow Preventer': 5,
    'Drain - Floor': 25,
    'Drain - Roof': 25,
    'Drain Cleanout': 25,
    'Drinking Fountain': 15,
    'Effluent Neutralizer': 5,
    'Emergency Eye Wash': 15,
    'Emergency Shower': 15,
    'Expansion Tank': 20,
    'Faucet - Duplex': 10,
    'Faucet - Single': 10,
    'Faucet - Spray Head': 10,
    'Fire Hydrant': 10,
    'Fire Sprinkler Head': 10,
    'Hose Bib': 20,
    'Lavatory': 30,
    'Meter - Blow Down Water': 15,
    'Meter - Make-up Water': 15,
    'Meter - Natural Gas': 25,
    'Meter - Water': 25,
    'Pump - Domestic Water Booster': 25,
    'Pump - Hot Water Circulating': 10,
    'Pump - Sump': 10,
    'Shock Arrestor': 15,
    'Shower': 10,
    'Sink - Kitchen': 30,
    'Sink - Laboratory': 30,
    'Sink - Mop': 30,
    'Strainer': 20,
    'Thermometer': 20,
    'Trap': 20,
    'Trap - Grease': 30,
    'Trap - Primer': 10,
    'Urinal': 30,
    'Pump - Vacuum': 10,
    'Valve - Balancing': 25,
    'Valve - Check': 10,
    'Valve - Gas Cock': 25,
    'Valve - Isolation': 20,
    'Valve - Post Indicator': 30,
    'Valve - Pressure Relief': 10,
    'Washer Hose Box': 20,
    'Water Closet': 30,
    'Water Cooler': 15,
    'Water Heater - Electric': 10,
    'Water Heater - Instantaneous': 10,
    'Water Heater -Fuel  Fired': 10,
    'Water Tempering Station': 10,
  },
};

export const LIFE_EXPECTANCY_BASIS_BY_SYSTEM: Record<string, Record<string, LifetimeBasis>> = {
  controls: {
    'Computer - Automation System': 'exact',
    'Control Valve - Actuator': 'exact',
    'Control Valve -2-Way': 'median',
    'Control Valve -3-Way': 'median',
    'Controller - Automation System': 'exact',
    'Controller - Dew Point': 'exact',
    'Controller - Differential Pressure': 'exact',
    'Controller - Economizer': 'exact',
    'Controller - Flame Safeguard': 'exact',
    'Controller - Heat Tape Temperature': 'exact',
    'Controller - Humidity': 'exact',
    'Controller - Pressure': 'exact',
    'Controller - Temperature': 'exact',
    'Damper - Barometric': 'exact',
    'Damper - Motor Operated': 'exact',
    'Damper Actuator': 'median',
    'Damper End Switch': 'median',
    'Freeze Stat': 'item',
    'Humdistat': 'item',
    'Magnehelic Gauge - Analog': 'exact',
    'Magnehelic Gauge - Digital': 'exact',
    'Meter - Electric': 'exact',
    'Meter - Flow': 'exact',
    'Meter - Natural Gas': 'exact',
    'Meter - Water': 'exact',
    'Refrigerant Monitor': 'item',
    'Relay': 'item',
    'Sensor - Air Flow': 'exact',
    'Sensor - Carbon Dioxide': 'exact',
    'Sensor - Carbon Monoxide': 'exact',
    'Sensor - Current': 'exact',
    'Sensor - Dew Point': 'exact',
    'Sensor - Differential Pressure': 'exact',
    'Sensor - Enthalpy': 'exact',
    'Sensor - Humidity': 'exact',
    'Sensor - Light Level': 'exact',
    'Sensor - Methane': 'exact',
    'Sensor - Occupancy': 'exact',
    'Sensor - Temperature': 'exact',
    'Sensor - Temperature & Humidity': 'exact',
    'Sensor - Velocity': 'exact',
    'Sensor - Water Flow': 'exact',
    'Smoke Damper': 'median',
    'Smoke Detector': 'median',
    'Switch - Flow': 'exact',
    'Switch - Freeze Protection': 'exact',
    'Switch - High Pressure': 'exact',
    'Thermometer': 'item',
    'Thermostat': 'item',
    'Vapor Detection System': 'item',
  },
  electrical: {
    'Automatic Transfer Switch': 'item',
    'Circuit Breaker - Arc Fault': 'exact',
    'Circuit Breaker - Ground Fault': 'exact',
    'Circuit Breaker - Main': 'exact',
    'Circuit Breaker - Over Current': 'exact',
    'Circuit Breaker - Tie': 'exact',
    'Disconnect Switch - Fused': 'exact',
    'Disconnect Switch - Non Fused': 'exact',
    'Emergency Stop Switch': 'item',
    'Energy Monitor': 'item',
    'Fire - Alarm Panel': 'exact',
    'Fire - Annuciator/Strobe': 'sub-match',
    'Fire - Heat Detector': 'exact',
    'Fire - Pull Station': 'exact',
    'Fuse': 'item',
    'Generator - Emergency Power': 'exact',
    'Generator - Standy Power': 'sub-match',
    'Heat Tape - Freeze Protection': 'exact',
    'Heater - Compressor Crankcase': 'exact',
    'Heater - Cooling Tower Sump': 'exact',
    'Heater - Duct': 'exact',
    'Lighting Control Panel': 'item',
    'Lighting Dimmer Switch': 'item',
    'Lighting Fixture - Emergency': 'exact',
    'Lighting Fixture - Exit': 'exact',
    'Lighting Fixture - Indoor': 'exact',
    'Lighting Fixture - Night Light': 'exact',
    'Lighting Fixture - Outdoor': 'exact',
    'Lighting Fixture - Ultraviolet': 'exact',
    'Motor': 'item',
    'Motor Control Center': 'item',
    'Motor Starter': 'item',
    'Power Panel - Lighting': 'exact',
    'Power Panel - Mechanical': 'exact',
    'Relay': 'item',
    'Switch - Wall  On/Off': 'exact',
    'Switchboard': 'item',
    'Transformer - Utility': 'exact',
    'Transformer - Voltage Boost': 'exact',
    'Transformer - Voltage Step Down': 'exact',
    'TVSS - Surge Protection Device': 'item',
    'UPS': 'item',
    'Variable Frequency Drive': 'item',
  },
  mechanical: {
    'Air Conditioner': 'median',
    'Air Handling Unit - Constant Volume': 'sub-match',
    'Air Handling Unit - Dedicated Outdoor Air': 'sub-match',
    'Air Handling Unit - Variable Volume': 'sub-match',
    'Air Terminal - Constant Volume': 'median',
    'Air Terminal - Variable Volume': 'median',
    'Air Washer': 'item',
    'Boiler - Hot Water': 'sub-match',
    'Boiler - Steam': 'median',
    'Burner': 'item',
    'Coil - Direct Expansion': 'median',
    'Coil - Fin Tube': 'median',
    'Coil - Steam': 'sub-match',
    'Coil - Water': 'sub-match',
    'Compressor': 'item',
    'Condensing Unit': 'item',
    'Cooling Tower - Closed Loop': 'median',
    'Cooling Tower - Open Loop': 'median',
    'Damper': 'item',
    'Damper - Fire': 'item',
    'Damper - Minimum Outdoor': 'item',
    'Damper - Outdoor Air': 'item',
    'Damper - Relief/Exhaust Air': 'item',
    'Damper - Return Air': 'item',
    'Damper - Smoke': 'item',
    'Ductwork - Access Door': 'item',
    'Ductwork - Exhaust Air': 'item',
    'Ductwork - Insulation': 'item',
    'Ductwork - Supply Air': 'item',
    'Energy Recovery Unit': 'median',
    'Engine': 'item',
    'Fan - Boiler Draft Inducer': 'median',
    'Fan - Exhaust': 'median',
    'Fan - Filter Fan Unit': 'median',
    'Fan - Relief': 'median',
    'Fan - Supply': 'median',
    'Fan Coil Unit': 'median',
    'Furnace - Electric': 'item',
    'Furnace - Fuel Fired': 'item',
    'Heat Exchanger - Plate and Frame': 'exact',
    'Heat Exchanger - Shell and Tube': 'exact',
    'Heat Pump - Air to Air': 'sub-match',
    'Heat Pump - Water to Air': 'sub-match',
    'Heat Pump - Water to Water': 'sub-match',
    'Pump': 'median',
    'Pump - Booster': 'median',
    'Pump - Chilled Water': 'median',
    'Pump - Condenser Water': 'median',
    'Pump - Heating Water': 'median',
    'Pump - PreHeat Coil': 'median',
    'Pump - Vacuum': 'median',
    'Radiant Heater': 'median',
    'Turbine': 'item',
    'Unit Heater - Electric': 'sub-match',
    'Unit Heater - Gas Fired': 'sub-match',
    'Unit Heater - Hot Water': 'sub-match',
    'Unit Heater - Steam': 'sub-match',
  },
  plumbing: {
    'Air Compressor - Reciprocating': 'exact',
    'Air Compressor - Screw': 'exact',
    'Aquastat': 'item',
    'Back Flow Preventer': 'item',
    'Drain - Floor': 'exact',
    'Drain - Roof': 'exact',
    'Drain Cleanout': 'median',
    'Drinking Fountain': 'item',
    'Effluent Neutralizer': 'item',
    'Emergency Eye Wash': 'item',
    'Emergency Shower': 'item',
    'Expansion Tank': 'item',
    'Faucet - Duplex': 'exact',
    'Faucet - Single': 'exact',
    'Faucet - Spray Head': 'exact',
    'Fire Hydrant': 'median',
    'Fire Sprinkler Head': 'median',
    'Hose Bib': 'item',
    'Lavatory': 'item',
    'Meter - Blow Down Water': 'sub-match',
    'Meter - Make-up Water': 'sub-match',
    'Meter - Natural Gas': 'exact',
    'Meter - Water': 'exact',
    'Pump - Domestic Water Booster': 'exact',
    'Pump - Hot Water Circulating': 'exact',
    'Pump - Sump': 'exact',
    'Shock Arrestor': 'item',
    'Shower': 'item',
    'Sink - Kitchen': 'item',
    'Sink - Laboratory': 'exact',
    'Sink - Mop': 'exact',
    'Strainer': 'item',
    'Thermometer': 'item',
    'Trap': 'median',
    'Trap - Grease': 'exact',
    'Trap - Primer': 'exact',
    'Urinal': 'item',
    'Pump - Vacuum': 'exact',
    'Valve - Balancing': 'exact',
    'Valve - Check': 'exact',
    'Valve - Gas Cock': 'exact',
    'Valve - Isolation': 'exact',
    'Valve - Post Indicator': 'exact',
    'Valve - Pressure Relief': 'exact',
    'Washer Hose Box': 'item',
    'Water Closet': 'item',
    'Water Cooler': 'item',
    'Water Heater - Electric': 'exact',
    'Water Heater - Instantaneous': 'exact',
    'Water Heater -Fuel  Fired': 'exact',
    'Water Tempering Station': 'item',
  },
};

export function lookupLifetime(system: string, classification: string): number | undefined {
  // Exact match against the life tables (classification now comes straight from them). Falls back
  // to the legacy dropdown-vocabulary map so assessments saved before the table-only change keep
  // their auto-RSL.
  return LIFETIME_BY_LABEL[system]?.[classification] ?? LIFE_EXPECTANCY_BY_SYSTEM[system]?.[classification];
}

export function lookupLifetimeBasis(system: string, classification: string): LifetimeBasis | undefined {
  return LIFE_EXPECTANCY_BASIS_BY_SYSTEM[system]?.[classification];
}

/* Awaiting Paul's decision: the Item's sub-variants disagreed and we defaulted to the median,
   or the workbook has no life-table row for this dropdown value. See
   design/lifetime-mapping-review.csv. */
export const NEEDS_LIFETIME_REVIEW: Record<string, string[]> = {
  controls: ['Automation System', 'Control Valve -2-Way', 'Control Valve -3-Way', 'Damper Actuator', 'Damper End Switch', 'Differential Pressure Switch', 'Smoke Damper', 'Smoke Detector'],
  electrical: ['Current Transformer', 'Hand-Off-Auto Switch', 'Occupancy Sensor'],
  mechanical: ['Air Conditioner', 'Air Separator', 'Air Terminal - Constant Volume', 'Air Terminal - Variable Volume', 'Boiler - Steam', 'Chemical Feed Tank', 'Coil - Direct Expansion', 'Coil - Fin Tube', 'Cooling Tower - Closed Loop', 'Cooling Tower - Open Loop', 'Dehumidifier', 'Diffuser, Register, Grille', 'Duct Silencer', 'Ductless Split System', 'Energy Recovery Unit', 'Energy Recovery Wheel', 'Exhaust Snorkel', 'Expansion Tank', 'Fan - Boiler Draft Inducer', 'Fan - Exhaust', 'Fan - Filter Fan Unit', 'Fan - Relief', 'Fan - Supply', 'Fan Coil Unit', 'Filter - Electro-Static', 'Filter - Final Filter', 'Filter - HEPA', 'Filter - Pre Filter', 'Fume Hood - Canopy', 'Fume Hood - Kitchen', 'Fume Hood - Laboratory', 'Heater - Electric', 'Heater -Hot Water', 'Heater -Steam', 'Humidifier - Steam', 'Humidifier - Water', 'Pump', 'Pump - Booster', 'Pump - Chilled Water', 'Pump - Condenser Water', 'Pump - Heating Water', 'Pump - PreHeat Coil', 'Pump - Vacuum', 'Radiant Heater', 'Roof Top Unit', 'Water Chiller - Air Cooled', 'Water Chiller - Water Cooled'],
  plumbing: ['Drain Cleanout', 'Fire Hydrant', 'Fire Sprinkler Head', 'Flush Valve', 'Trap'],
};

/* The workbook's life tables verbatim, for an in-app equivalent of Paul's "Go To Table". */
export interface LifetimeRow { item: string; subItem: string; years: number }
export const LIFE_EXPECTANCY_ROWS: Record<string, LifetimeRow[]> = {
  controls: [
    { item: 'Actuator', subItem: 'Hydraulic', years: 15 },
    { item: 'Actuator', subItem: 'Pneumatic', years: 20 },
    { item: 'Actuator', subItem: 'Self Contained', years: 10 },
    { item: 'Computer', subItem: 'Automation System', years: 10 },
    { item: 'Control System', subItem: 'Electronic', years: 20 },
    { item: 'Control System', subItem: 'Electric', years: 20 },
    { item: 'Control System', subItem: 'Pneumatic', years: 15 },
    { item: 'Control System', subItem: 'Computerized - DDC System', years: 20 },
    { item: 'Control Valve', subItem: 'Actuator', years: 10 },
    { item: 'Control Valve', subItem: '2-Way & 3-Way', years: 20 },
    { item: 'Controller', subItem: 'Automation System', years: 15 },
    { item: 'Controller', subItem: 'Dew Point', years: 15 },
    { item: 'Controller', subItem: 'Differential Pressure', years: 15 },
    { item: 'Controller', subItem: 'Economizer', years: 15 },
    { item: 'Controller', subItem: 'Flame Safeguard', years: 15 },
    { item: 'Controller', subItem: 'Heat Tape Temperature', years: 10 },
    { item: 'Controller', subItem: 'Humidity', years: 15 },
    { item: 'Controller', subItem: 'Pressure', years: 15 },
    { item: 'Controller', subItem: 'Temperature', years: 15 },
    { item: 'Damper', subItem: 'Barometric', years: 15 },
    { item: 'Damper', subItem: 'Motor Operated', years: 15 },
    { item: 'Damper', subItem: 'Pneumatic Actuator', years: 20 },
    { item: 'Damper', subItem: 'End Switch', years: 15 },
    { item: 'Damper', subItem: 'Electric Actuator', years: 15 },
    { item: 'Display', subItem: 'Digital', years: 10 },
    { item: 'Display', subItem: 'Analog', years: 10 },
    { item: 'Freeze Stat', subItem: 'Freeze Stat', years: 10 },
    { item: 'Humdistat', subItem: 'Humdistat', years: 15 },
    { item: 'Magnehelic Gauge', subItem: 'Analog', years: 10 },
    { item: 'Magnehelic Gauge', subItem: 'Digital', years: 10 },
    { item: 'Meter', subItem: 'Electric', years: 25 },
    { item: 'Meter', subItem: 'Flow', years: 20 },
    { item: 'Meter', subItem: 'Natural Gas', years: 25 },
    { item: 'Meter', subItem: 'Water', years: 25 },
    { item: 'Refrigerant Monitor', subItem: 'Refrigerant Monitor', years: 10 },
    { item: 'Relay', subItem: 'Relay', years: 10 },
    { item: 'Sensor', subItem: 'Air Flow', years: 10 },
    { item: 'Sensor', subItem: 'Carbon Dioxide', years: 10 },
    { item: 'Sensor', subItem: 'Carbon Monoxide', years: 10 },
    { item: 'Sensor', subItem: 'Dew Point', years: 10 },
    { item: 'Sensor', subItem: 'Differential Pressure', years: 10 },
    { item: 'Sensor', subItem: 'Enthalpy', years: 10 },
    { item: 'Sensor', subItem: 'Humidity', years: 10 },
    { item: 'Sensor', subItem: 'Light Level', years: 10 },
    { item: 'Sensor', subItem: 'Methane', years: 10 },
    { item: 'Sensor', subItem: 'Occupancy', years: 10 },
    { item: 'Sensor', subItem: 'Temperature', years: 10 },
    { item: 'Sensor', subItem: 'Temperature & Humidity', years: 10 },
    { item: 'Sensor', subItem: 'Velocity', years: 10 },
    { item: 'Sensor', subItem: 'Water Flow', years: 10 },
    { item: 'Sensor', subItem: 'Current', years: 10 },
    { item: 'Smoke', subItem: 'Damper', years: 15 },
    { item: 'Smoke', subItem: 'Detector', years: 10 },
    { item: 'Switch', subItem: 'Differential Pressure', years: 15 },
    { item: 'Switch', subItem: 'Flow', years: 15 },
    { item: 'Switch', subItem: 'Freeze Protection', years: 10 },
    { item: 'Switch', subItem: 'High Pressure', years: 10 },
    { item: 'Thermometer', subItem: 'Thermometer', years: 15 },
    { item: 'Thermostat', subItem: 'Thermostat', years: 15 },
    { item: 'Vapor Detection System', subItem: 'Vapor Detection System', years: 10 },
  ],
  electrical: [
    { item: 'Automatic Transfer Switch', subItem: 'Automatic Transfer Switch', years: 25 },
    { item: 'Battery', subItem: 'Solar System', years: 5 },
    { item: 'Circuit Breaker', subItem: 'Arc Fault', years: 30 },
    { item: 'Circuit Breaker', subItem: 'Ground Fault', years: 30 },
    { item: 'Circuit Breaker', subItem: 'Main', years: 30 },
    { item: 'Circuit Breaker', subItem: 'Over Current', years: 30 },
    { item: 'Circuit Breaker', subItem: 'Tie', years: 30 },
    { item: 'Disconnect Switch', subItem: 'Fused', years: 15 },
    { item: 'Disconnect Switch', subItem: 'Non Fused', years: 20 },
    { item: 'Emergency Stop Switch', subItem: 'Emergency Stop Switch', years: 20 },
    { item: 'Energy Monitor', subItem: 'Energy Monitor', years: 15 },
    { item: 'Fire', subItem: 'Alarm Panel', years: 15 },
    { item: 'Fire', subItem: 'Annunciator/Strobe', years: 20 },
    { item: 'Fire', subItem: 'Heat Detector', years: 30 },
    { item: 'Fire', subItem: 'Pull Station', years: 30 },
    { item: 'Fuse', subItem: 'Fuse', years: 5 },
    { item: 'Generator', subItem: 'Emergency Power', years: 25 },
    { item: 'Generator', subItem: 'Stand-by Power', years: 25 },
    { item: 'Generator', subItem: 'Wind Turbine', years: 20 },
    { item: 'Heat Tape', subItem: 'Freeze Protection', years: 10 },
    { item: 'Heater', subItem: 'Compressor Crankcase', years: 10 },
    { item: 'Heater', subItem: 'Cooling Tower Sump', years: 10 },
    { item: 'Heater', subItem: 'Duct', years: 15 },
    { item: 'Light Bulb', subItem: 'LED', years: 10 },
    { item: 'Light Bulb', subItem: 'Incandescent', years: 1 },
    { item: 'Light Bulb', subItem: 'Fluorescent', years: 5 },
    { item: 'Lighting Control Panel', subItem: 'Lighting Control Panel', years: 30 },
    { item: 'Lighting Dimmer Switch', subItem: 'Lighting Dimmer Switch', years: 15 },
    { item: 'Lighting Fixture', subItem: 'Emergency', years: 20 },
    { item: 'Lighting Fixture', subItem: 'Exit', years: 20 },
    { item: 'Lighting Fixture', subItem: 'Indoor', years: 20 },
    { item: 'Lighting Fixture', subItem: 'Night Light', years: 15 },
    { item: 'Lighting Fixture', subItem: 'Outdoor', years: 20 },
    { item: 'Lighting Fixture', subItem: 'Ultraviolet', years: 10 },
    { item: 'Motor', subItem: 'Motor', years: 20 },
    { item: 'Motor Control Center', subItem: 'Motor Control Center', years: 30 },
    { item: 'Motor Starter', subItem: 'Motor Starter', years: 20 },
    { item: 'Power Panel', subItem: 'Lighting', years: 30 },
    { item: 'Power Panel', subItem: 'Mechanical', years: 30 },
    { item: 'Relay', subItem: 'Relay', years: 20 },
    { item: 'Sensor', subItem: 'Occupancy', years: 10 },
    { item: 'Solar Panel', subItem: 'Solar Panel', years: 25 },
    { item: 'Switch', subItem: 'Wall  On/Off', years: 30 },
    { item: 'Switch', subItem: 'Hand-Off-Auto Switch', years: 30 },
    { item: 'Switchboard', subItem: 'Switchboard', years: 30 },
    { item: 'Transformer', subItem: 'Current', years: 20 },
    { item: 'Transformer', subItem: 'Utility', years: 30 },
    { item: 'Transformer', subItem: 'Voltage Boost', years: 30 },
    { item: 'Transformer', subItem: 'Voltage Step Down', years: 3 },
    { item: 'TVSS - Surge Protection Device', subItem: 'Surge Protection Device', years: 10 },
    { item: 'UPS', subItem: 'UPS', years: 10 },
    { item: 'Variable Frequency Drive', subItem: 'Variable Frequency Drive', years: 10 },
    { item: 'Wiring', subItem: 'Copper', years: 100 },
    { item: 'Wiring', subItem: 'Aluminum', years: 100 },
  ],
  mechanical: [
    { item: 'Air Conditioner', subItem: 'Window Unit', years: 10 },
    { item: 'Air Conditioner', subItem: 'Residential Single or Split Package', years: 15 },
    { item: 'Air Conditioner', subItem: 'Commercial Through the Wall', years: 15 },
    { item: 'Air Conditioner', subItem: 'Water Cooled Package', years: 15 },
    { item: 'Air Handling Unit', subItem: 'Indoor Constant or Variable Volume', years: 25 },
    { item: 'Air Handling Unit', subItem: 'Outdoor Constant or Variable Volume', years: 20 },
    { item: 'Air Handling Unit', subItem: 'Dedicated Outdoor Air Unit', years: 20 },
    { item: 'Air Terminal', subItem: 'Diffusers, Grilles, and Registers', years: 30 },
    { item: 'Air Terminal', subItem: 'Induction and Fan Coil units', years: 20 },
    { item: 'Air Terminal', subItem: 'VAV Boxes', years: 20 },
    { item: 'Air Washer', subItem: 'Air Washer', years: 15 },
    { item: 'Boiler', subItem: 'Steel Water Tube', years: 25 },
    { item: 'Boiler', subItem: 'Steel Fire Tube', years: 25 },
    { item: 'Boiler', subItem: 'Cast Iron', years: 35 },
    { item: 'Boiler', subItem: 'Electric', years: 15 },
    { item: 'Burner', subItem: 'Gas or Oil Fired', years: 20 },
    { item: 'Chiller', subItem: 'Reciprocating', years: 20 },
    { item: 'Chiller', subItem: 'Centrifugal', years: 25 },
    { item: 'Chiller', subItem: 'Absorption', years: 25 },
    { item: 'Coil', subItem: 'DX, Water, or Steam', years: 20 },
    { item: 'Coil', subItem: 'Electric', years: 15 },
    { item: 'Compressor', subItem: 'Reciprocating', years: 20 },
    { item: 'Condensing Unit', subItem: 'Air Cooled', years: 20 },
    { item: 'Condensing Unit', subItem: 'Evaporative', years: 20 },
    { item: 'Control System', subItem: 'Pneumatic', years: 20 },
    { item: 'Control System', subItem: 'Electric', years: 15 },
    { item: 'Control System', subItem: 'Electronic', years: 15 },
    { item: 'Cooling Tower', subItem: 'Galvanized', years: 20 },
    { item: 'Cooling Tower', subItem: 'Wood', years: 20 },
    { item: 'Cooling Tower', subItem: 'Ceramic', years: 35 },
    { item: 'Damper', subItem: 'Damper', years: 20 },
    { item: 'Ductwork', subItem: 'Ductwork', years: 30 },
    { item: 'Energy Recovery Unit', subItem: 'Outdoor Constant or Variable Volume', years: 20 },
    { item: 'Energy Recovery Unit', subItem: 'Indoor Constant or Variable Volume', years: 25 },
    { item: 'Engine', subItem: 'Reciprocating', years: 20 },
    { item: 'Fan', subItem: 'Centrifugal', years: 25 },
    { item: 'Fan', subItem: 'Axial', years: 20 },
    { item: 'Fan', subItem: 'Propeller', years: 15 },
    { item: 'Fan', subItem: 'Roof Ventilator', years: 20 },
    { item: 'Furnace', subItem: 'Gas or Oil Fired', years: 20 },
    { item: 'Heat Exchanger', subItem: 'Shell and Tube', years: 25 },
    { item: 'Heat Exchanger', subItem: 'Plate and Frame', years: 25 },
    { item: 'Heat Pump', subItem: 'Residential Air-Air', years: 15 },
    { item: 'Heat Pump', subItem: 'Commercial Air-Air', years: 15 },
    { item: 'Heat Pump', subItem: 'Commercial Water-Air', years: 20 },
    { item: 'Insulation', subItem: 'Molded', years: 20 },
    { item: 'Insulation', subItem: 'Blanket', years: 25 },
    { item: 'Motor', subItem: 'Electric', years: 20 },
    { item: 'Pump', subItem: 'Base Mounted', years: 20 },
    { item: 'Pump', subItem: 'In-Line Mounted', years: 10 },
    { item: 'Pump', subItem: 'Sump and Well', years: 10 },
    { item: 'Pump', subItem: 'Steam Condensate', years: 10 },
    { item: 'Radiant Heater', subItem: 'Electric', years: 10 },
    { item: 'Radiant Heater', subItem: 'Hot Water or Steam', years: 25 },
    { item: 'Roof Top Air Condition Unit', subItem: 'Single Zone', years: 15 },
    { item: 'Roof Top Air Condition Unit', subItem: 'Mutli-Zone', years: 15 },
    { item: 'Transformer', subItem: 'Electric', years: 30 },
    { item: 'Turbine', subItem: 'Steam', years: 30 },
    { item: 'Unit Heater', subItem: 'Gas or Electric', years: 15 },
    { item: 'Unit Heater', subItem: 'Hot Water or Steam', years: 20 },
    { item: 'Valve Actuator', subItem: 'Hydraulic', years: 15 },
    { item: 'Valve Actuator', subItem: 'Pneumatic', years: 20 },
    { item: 'Valve Actuator', subItem: 'Self-Contained', years: 10 },
  ],
  plumbing: [
    { item: 'Air Compressor', subItem: 'Reciprocating', years: 10 },
    { item: 'Air Compressor', subItem: 'Screw', years: 10 },
    { item: 'Aquastat', subItem: 'Aquastat', years: 10 },
    { item: 'Back Flow Preventer', subItem: 'Back Flow Preventer', years: 5 },
    { item: 'Drain', subItem: 'Floor', years: 25 },
    { item: 'Drain', subItem: 'Roof', years: 25 },
    { item: 'Drain', subItem: 'Cleanout', years: 30 },
    { item: 'Drinking Fountain', subItem: 'Drinking Fountain', years: 15 },
    { item: 'Effluent Neutralizer', subItem: 'Effluent Neutralizer', years: 5 },
    { item: 'Emergency', subItem: 'Eye Wash', years: 15 },
    { item: 'Emergency', subItem: 'Shower', years: 15 },
    { item: 'Expansion Tank', subItem: 'Expansion Tank', years: 20 },
    { item: 'Faucet', subItem: 'Duplex', years: 10 },
    { item: 'Faucet', subItem: 'Single', years: 10 },
    { item: 'Faucet', subItem: 'Spray Head', years: 10 },
    { item: 'Fire', subItem: 'Hydrant', years: 30 },
    { item: 'Fire', subItem: 'Sprinkler Head', years: 10 },
    { item: 'Hose Bib', subItem: 'Hose Bib', years: 20 },
    { item: 'Lavatory', subItem: 'Lavatory', years: 30 },
    { item: 'Meter', subItem: 'Water Blow Down', years: 15 },
    { item: 'Meter', subItem: 'Water Make-Up', years: 15 },
    { item: 'Meter', subItem: 'Natural Gas', years: 25 },
    { item: 'Meter', subItem: 'Water', years: 25 },
    { item: 'Piping', subItem: 'Polypropylene', years: 30 },
    { item: 'Piping', subItem: 'PVC', years: 30 },
    { item: 'Piping', subItem: 'Cast Iron', years: 40 },
    { item: 'Piping', subItem: 'Galvanized', years: 30 },
    { item: 'Piping', subItem: 'Copper', years: 30 },
    { item: 'Pump', subItem: 'Domestic Water Booster', years: 25 },
    { item: 'Pump', subItem: 'Hot Water Circulating', years: 10 },
    { item: 'Pump', subItem: 'Sump', years: 10 },
    { item: 'Pump', subItem: 'Vacuum', years: 10 },
    { item: 'Pump', subItem: 'Septic', years: 10 },
    { item: 'Shock Arrestor', subItem: 'Shock Arrestor', years: 15 },
    { item: 'Shower', subItem: 'Head Assembly', years: 10 },
    { item: 'Shower', subItem: 'Tempering Valve', years: 10 },
    { item: 'Sink', subItem: 'Kitchen Stainless Steel', years: 30 },
    { item: 'Sink', subItem: 'Laboratory', years: 30 },
    { item: 'Sink', subItem: 'Mop', years: 30 },
    { item: 'Strainer', subItem: 'Strainer', years: 20 },
    { item: 'Thermometer', subItem: 'Thermometer', years: 20 },
    { item: 'Trap', subItem: 'Trap', years: 20 },
    { item: 'Trap', subItem: 'Grease', years: 30 },
    { item: 'Trap', subItem: 'Primer', years: 10 },
    { item: 'Urinal', subItem: 'Urinal', years: 30 },
    { item: 'Valve', subItem: 'Flush', years: 10 },
    { item: 'Valve', subItem: 'Balancing', years: 25 },
    { item: 'Valve', subItem: 'Check', years: 10 },
    { item: 'Valve', subItem: 'Gas Cock', years: 25 },
    { item: 'Valve', subItem: 'Isolation', years: 20 },
    { item: 'Valve', subItem: 'Post Indicator', years: 30 },
    { item: 'Valve', subItem: 'Pressure Relief', years: 10 },
    { item: 'Washer Hose Box', subItem: 'Washer Hose Box', years: 20 },
    { item: 'Water Closet', subItem: 'Water Closet', years: 30 },
    { item: 'Water Cooler', subItem: 'Water Cooler', years: 15 },
    { item: 'Water Heater', subItem: 'Instantaneous', years: 10 },
    { item: 'Water Heater', subItem: 'Electric', years: 10 },
    { item: 'Water Heater', subItem: 'Fuel  Fired', years: 10 },
    { item: 'Water Tempering Station', subItem: 'Water Tempering Station', years: 10 },
  ],
};

/* The canonical equipment-type label for a life-table row — this is what the assessment stores
   in `asset.description` when the user picks the row, and the key everything else looks the
   lifetime up by. Item and Sub-Item are joined as "Item - Sub-Item", except the many rows whose
   Sub-Item just repeats the Item (Fuse|Fuse, Motor|Motor, Ductwork|Ductwork, …), which collapse
   to the bare Item. Whitespace is normalised because the workbook carries stray double/trailing
   spaces ("Reciprocating  ", "Switch  ") that must not leak into the stored value or the key. */
export function classificationLabel(row: LifetimeRow): string {
  const item = row.item.replace(/\s+/g, ' ').trim();
  const sub = row.subItem.replace(/\s+/g, ' ').trim();
  return sub && sub !== item ? `${item} - ${sub}` : item;
}

/* Exact classification -> expected life, per system, built from the life tables above. Because a
   classification is now chosen FROM these tables (not a separate dropdown vocabulary), the lookup
   is an exact map — the old fuzzy item/median bridge is no longer needed. First row wins on the
   rare duplicate label. */
const LIFETIME_BY_LABEL: Record<string, Record<string, number>> = Object.fromEntries(
  Object.entries(LIFE_EXPECTANCY_ROWS).map(([system, rows]) => {
    const map: Record<string, number> = {};
    for (const r of rows) {
      const label = classificationLabel(r);
      if (!(label in map)) map[label] = r.years;
    }
    return [system, map];
  }),
);
